import React from "react";
import AppSettings from "../Settings/AppSettings";
import Utils from "../Common/Utils";

function Login(props) {

  function handle_login() {
    let rto = "rto=" + Utils.get_current_root_url() + "callback/login";
    let redirect_url = AppSettings.SAMS_SSO_URL + "?m=get&" + rto;
    window.location.href = redirect_url;
  }
  React.useEffect(() => {
    handle_login();
    Utils.SetWindowTitle("Login");
  });

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="col min-vh-100 d-table">
            <div className="align-middle d-table-cell">
              <div className="mx-auto row align-items-center">
                <br></br>
              </div>
              <div className="mx-auto row align-items-center">
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Login;
